import { MapProperty } from 'cadenza/map/map-property';
import { FeatureInfo } from 'cadenza/map/interactions/feature-info';
import { MeasureDistance } from 'cadenza/map/interactions/measure-distance';
import { MeasureArea } from 'cadenza/map/interactions/measure-area';
import { FeatureSelectionInteraction } from 'cadenza/map/interactions/feature-selection-interaction';
import { PolygonFeatureSelection } from 'cadenza/map/interactions/polygon-feature-selection';
import { AddressInfoInteraction } from 'cadenza/map/interactions/address-info-interaction';
import { DragZoomInteraction } from 'cadenza/map/interactions/drag-zoom-interaction';
import { WorkbookSelectionInteraction } from 'cadenza/map/interactions/workbook-selection-interaction';
import { assert } from 'cadenza/utils/custom-error';
import { MapAction } from 'cadenza/map/actions/map-action';

export const MAP_INTERACTIONS = {
  FEATURE_INFO: 'FeatureInfo',
  ADDRESS_INFO_INTERACTION: 'AddressInfoInteraction',
  MEASURE_DISTANCE: 'MeasureDistance',
  MEASURE_AREA: 'MeasureArea',
  CAPTURE_COORDINATES: 'CaptureCoordinates',
  FEATURE_SELECTION: 'FeatureSelection',
  POLYGON_FEATURE_SELECTION: 'PolygonFeatureSelection',
  DUMMY_GEOLOCATION_INTERACTION: 'DummyGeolocationInteraction',
  DUMMY_TIMELINE_INTERACTION: 'DummyTimelineInteraction',
  DRAG_ZOOM_INTERACTION: 'DragZoomInteraction',
  DIRECTIONS_ROUTING_INTERACTION: 'DirectionsRoutingInteraction',
  ISOCHRONES_ROUTING_INTERACTION: 'IsochronesRoutingInteraction',
  DELETE_GEOMETRY_INTERACTION: 'DeleteGeometryInteraction',
  SELECT_GEOMETRY_INTERACTION: 'SelectGeometryInteraction',
  WORKBOOK_SELECTION_INTERACTION: 'WorkbookSelectionInteraction',
  CLIENT_GEOMETRY_EDIT_INTERACTION: 'ClientGeometryEditInteraction',
  SERVER_GEOMETRY_EDIT_INTERACTION: 'ServerGeometryEditInteraction',
  WORKBOOK_SKETCH_SELECT_INTERACTION: 'WorkbookSketchSelectInteraction'
};

export class MapInteractionAction extends MapAction {

  #interaction;
  #interactionClass;
  #interactionName;

  constructor (map, { interaction, interactionClass, interactionName, ...options }) {
    super(map, options);
    assert(interaction, 'The interaction is required');
    assert(interactionClass, 'The interactionClass is required');
    assert(interactionName, 'The interactionName is required');
    this.#interaction = interaction;
    this.#interactionClass = interactionClass;
    this.#interactionName = interactionName;
  }

  isSupportedSync () {
    return true;
  }

  executeSync () {
    this.map.set(MapProperty.PRIMARY_INTERACTION, this.#interaction);
  }

  /**
   * Returns the interaction to the calling subclass
   *
   * @protected
   * @return {object} the interaction for this map action
   */
  get interaction () {
    return this.#interaction;
  }

  get interactionClass () {
    return this.#interactionClass;
  }

  get interactionName () {
    return this.#interactionName;
  }

  /**
   * If true, when the main interaction changes it is persisted in the session storage in order for
   * the active interaction to survive page reloads.
   * Override and return false for interactions that should not be persisted (e.g. routing).
   *
   * @return {boolean} If the interaction should be persisted to session storage
   */
  get persistInteractionToSession () {
    return true;
  }

}

export function isResettableMapInteraction (interaction) {
  return interaction instanceof FeatureInfo
   || interaction instanceof AddressInfoInteraction
   || interaction instanceof MeasureDistance
   || interaction instanceof MeasureArea
   || interaction instanceof FeatureSelectionInteraction
   || interaction instanceof WorkbookSelectionInteraction
   || interaction instanceof PolygonFeatureSelection
   || interaction instanceof DragZoomInteraction;
}
